(() => {
  const site = document.querySelector('[data-drg-site]');
  const nav = document.querySelector('[data-drg-nav]');
  const setNavState = () => nav?.classList.toggle('is-scrolled', window.scrollY > 24);
  setNavState();
  if (nav) {
    let navFrame = 0;
    window.addEventListener('scroll', () => {
      if (navFrame) return;
      navFrame = requestAnimationFrame(() => {
        setNavState();
        navFrame = 0;
      });
    }, { passive: true });
  }

  document.querySelectorAll('.drg-menu').forEach((menu) => {
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => menu.removeAttribute('open'));
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.drg-menu[open]').forEach((menu) => menu.removeAttribute('open'));
  });

  const aboutDialog = site?.querySelector('[data-drg-about-dialog]');
  const aboutOpen = site?.querySelector('[data-drg-about-open]');
  const aboutClose = site?.querySelector('[data-drg-about-close]');
  const closeAbout = () => {
    if (!aboutDialog) return;
    if (typeof aboutDialog.close === 'function') aboutDialog.close();
    else aboutDialog.removeAttribute('open');
  };

  aboutOpen?.addEventListener('click', () => {
    if (!aboutDialog) return;
    if (typeof aboutDialog.showModal === 'function') aboutDialog.showModal();
    else aboutDialog.setAttribute('open', '');
  });
  aboutClose?.addEventListener('click', closeAbout);
  aboutDialog?.addEventListener('click', (event) => {
    if (event.target === aboutDialog) closeAbout();
  });

  document.querySelectorAll('[data-drg-addon]').forEach((button) => {
    button.addEventListener('click', async () => {
      const variantId = Number(button.dataset.variantId);
      const status = button.closest('[data-drg-addon-panel]')?.querySelector('[data-drg-addon-status]');
      if (!variantId || button.disabled) return;

      const originalLabel = button.textContent;
      button.disabled = true;
      button.textContent = button.dataset.loadingLabel || 'Adding...';
      if (status) status.textContent = '';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });

        if (!response.ok) throw new Error('Add-on request failed');
        window.location.reload();
      } catch (error) {
        button.disabled = false;
        button.textContent = originalLabel;
        if (status) status.textContent = button.dataset.errorLabel || 'Could not add this item. Please try again.';
      }
    });
  });

  const reveals = site?.querySelectorAll('.drg-reveal') || [];
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    reveals.forEach((element) => element.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px' });

  reveals.forEach((element) => observer.observe(element));
})();
